<template lang="pug">
    div
        component(
            v-if="currentComponent"
            :is="currentComponent"
            ref="clonePageComponent"
        )
</template>

<script>
export default {
    name: 'ClonePageIndex',
    data() {
        return {
            components: {
                'PY': () =>
                    import(
                        '@/modules/traceability-report/views/pages/clone/content.vue'
                    )
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">

</style>
